import { __assign } from "tslib";
import { getUrlParamString } from "@ekuaibao/lib/lib/lib-util";
import { session } from '@ekuaibao/session-info';
export function initSessionFromUrl() {
    var userLocal = session.get('user') || {};
    var accessToken = getUrlParamString(window.location.search, 'accessToken');
    var corpId = getUrlParamString(window.location.search, 'corpId');
    var sessionObj = {};
    if (corpId) {
        sessionObj.corpId = corpId;
    }
    if (accessToken) {
        sessionObj.accessToken = accessToken;
    }
    session.set('user', __assign(__assign({}, userLocal), sessionObj));
}
